/**
 * Semiconductor-related critical mineral criticality (illustrative indices for dashboard display).
 * Replace or extend via API when backend endpoint is available.
 */
export const SEMICONDUCTOR_CRITICALITY = [
  {
    mineral: 'Gallium',
    role: 'GaAs/GaN substrates, RF & power electronics',
    importDependency: 'High',
    supplyConcentration: 'China ~98% refined output',
    criticalityIndex: 9.2,
    riskDriver: 'Export controls & single-source refining',
  },
  {
    mineral: 'Germanium',
    role: 'Fiber optics, IR optics, high-purity substrates',
    importDependency: 'High',
    supplyConcentration: 'China dominant in refining',
    criticalityIndex: 8.8,
    riskDriver: 'Dual-use controls and quota risk',
  },
  {
    mineral: 'Indium',
    role: 'ITO touchscreens, solder, compound semiconductors',
    importDependency: 'Very High',
    supplyConcentration: 'By-product of zinc smelting (concentrated)',
    criticalityIndex: 8.5,
    riskDriver: 'Thin supply elasticity; price spikes',
  },
  {
    mineral: 'Tantalum',
    role: 'Capacitors, high-reliability electronics',
    importDependency: 'Moderate–High',
    supplyConcentration: 'DRC/Rwanda mining; China processing',
    criticalityIndex: 7.9,
    riskDriver: 'Conflict minerals & ESG compliance',
  },
  {
    mineral: 'Rare Earths (Nd/Dy/Tb)',
    role: 'Permanent magnets, advanced nodes packaging',
    importDependency: 'Very High',
    supplyConcentration: 'China ~60% mining, ~90% separation',
    criticalityIndex: 9.5,
    riskDriver: 'Magnet supply chain chokepoint for EV & defence',
  },
  {
    mineral: 'Silicon (high-purity)',
    role: 'Wafer feedstock for logic & memory fabs',
    importDependency: 'Moderate',
    supplyConcentration: 'Few global polysilicon/wafer suppliers',
    criticalityIndex: 7.2,
    riskDriver: 'Fab capacity concentration (Taiwan/Korea)',
  },
];
